import { getCollectionActionTypes } from '@framework/state/Redux/collectionFactory';

export const keyWord = 'LEAGUE_TABLE_ALL';

export default getCollectionActionTypes(keyWord);
